<template>
  <v-container class="pa-0 dash-page">
    <div
      v-show="dashboardType !== 'customerReview'"
      ref="dashHead"
      class="dash-head w-100"
    >
      <home-dashboard-top v-model="dashboardType" />
    </div>
    <v-row
      v-if="
        dashboardType == 'customerReview' &&
        $store.getters.getpermission &&
        $store.getters.getpermission.includes('customerReview')
      "
      class="customer-review-row"
    >
      <v-col
        cols="12"
        class="py-0"
        :class="{ 'px-3': !isMobile ? true : false, 'ps-0': !isMobile ? true : false }"
      >
        <customerDesk @go-dashboard="dashboardType = 'homeTabDashboard'" />
      </v-col>
    </v-row>
    <!--
    <div
      v-if="
        dashboardType == 'homeTabDashboard' &&
        $store.getters.getpermission &&
        $store.getters.getpermission.includes('overview')
      "
      class="dash-scroll"
      :class="{ 'pa-2': ($vuetify.rtl && isMobile) || isTablet }"
    >
      <v-container class="dashboard-wrapper pa-0">
        <v-container
          class="dash-aside pa-0"
          :class="[$store.state.isMenuExpanded ? 'w-16' : 'w-18']"
        >
          <info-board hide-slider />
        </v-container>
      </v-container>
    </div>
    -->
  </v-container>
</template>

<script>
import HomeDashboardTop from "./partial/HomeDashboardTop.vue";
// import InfoBoard from "./partial/InfoBoard.vue";

export default {
  name: "Dashboard",
  components: {
    HomeDashboardTop,
    customerDesk: () => import("./customerDesk"),
    // InfoBoard,
  },
  data() {
    return {
      dashboardType: "homeTabDashboard",
      items: [],
      checkType: "payCheck",
    };
  },
  watch: {
    dashboardType() {
      this.$nextTick(this.setHeadHeight);
    },
    "$store.state.permissions": {
      deep: true,
      handler(newVal) {},
    },
  },
  mounted() {
    this.$nextTick(this.setHeadHeight);
    window.addEventListener("resize", this.setHeadHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setHeadHeight);
  },
  activated() {
    if (this.$store.state.teacherAccess) {
      this.$router.push({ name: "academyDashboard" });
    }
    this.$nextTick(this.setHeadHeight);
  },
  beforeMount() {
    if (this.$store.state.teacherAccess) {
      this.$router.push({ name: "academyDashboard" });
    }
  },
  methods: {
    setHeadHeight() {
      const el = this.$refs.dashHead;
      if (!el) return;
      this.$el.style.setProperty("--dash-head-h", el.offsetHeight + "px");
    },
  },
};
</script>
<style scoped>
.dash-page {
  --dash-sticky-top: 94px;
}
.customer-review-row {
  padding-top: 20px;
}
.dash-head {
  background-color: #f2f3f7;
  padding-bottom: 8px;
  width: 100%;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), inset 0 1px 0 #fff;
  border-radius: 4px;
}
.theme--dark .dash-head {
  background-color: #1e1e1e;
}
/*
.dash-scroll {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow-y: auto;
  height: calc(100vh - 94px - var(--dash-head-h, 0px) - 12px);
}
.dashboard-wrapper {
  display: flex;
  align-items: flex-start;
}
.w-16 {
  width: 16%;
}
.w-18 {
  width: 18%;
}
.dash-aside {
  position: sticky;
  top: 0;
  align-self: flex-start;
}
*/
.customers-review-box {
  background-color: #fff !important;
  color: #000 !important;
  border-radius: 5px !important;
  display: flex;
  align-items: center;
  width: fit-content;
  white-space: nowrap;
  height: 26px;
}
.v-chip:before {
  background-color: transparent !important;
}
::v-deep .v-chip-group .v-slide-group__content {
  padding: 0 !important;
}
/*
@media (max-width: 1220px) {
  .dash-scroll {
    height: auto;
    overflow: visible;
  }
  .dashboard-wrapper {
    flex-direction: column;
  }
  .dash-aside {
    position: static;
    width: 100%;
    top: auto;
  }
}
*/
</style>
